class CustomQtyATC extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }
  connectedCallback() {
    this.addEventListener("click", this.handleClick);
    this.syncQtyFromCart();

    this.cartUpdateListener = this.handleCartUpdate.bind(this);
    document.addEventListener("cart:updated", this.cartUpdateListener);
  }
  disconnectedCallback() {
    this.removeEventListener("click", this.handleClick);
    document.removeEventListener("cart:updated", this.cartUpdateListener);
  }
  handleClick(e) {
    var atcBtn = e.target.closest(".atc_btn_JS"),
        plusBtn = e.target.closest(".qty_btn.plus"),
        minusBtn = e.target.closest(".qty_btn.minus"),
        container = this,
        qtyValEl = container.querySelector(".qty_value"),
        qty = parseInt(qtyValEl.getAttribute("qty_value")) || 0,
        inventory = parseInt(container.getAttribute("inventory_quantity")) || 0,
        variantid = parseInt(container.getAttribute("variantid")),
        variantPrice = parseInt(container.getAttribute("variantPrice")),
        variantCompPrice = parseInt(container.getAttribute("variantCompPrice")),
        image = container.getAttribute("image");

    if (atcBtn) {
      container.classList.remove("qty_hide");
      qty++;
    }
    if (plusBtn) {
      qty++;
    }
    if (minusBtn) {
      if (qty <= 1) {
        container.classList.add("qty_hide");
        qty = 0;
      } else {
        qty--;
      }
    }
    qtyValEl.textContent = qty;
    qtyValEl.setAttribute("qty_value", qty);
    
    var plus = container.querySelector(".qty_btn.plus");
    if (qty >= inventory) {
      plus.classList.add("disabled");
    } else {
      plus.classList.remove("disabled");
    }

    if(container.closest('.pack-of-bundle')){
      if (atcBtn || plusBtn || minusBtn) {
        let isAdd = atcBtn || plusBtn;
        handleBundleUpdate(container, variantid, variantPrice, variantCompPrice, image, isAdd ? 'add' : 'remove');
      }
    }
  }

  syncQtyFromCart() {
    if(this.closest('.pack-of-bundle')) return;
    
        var container = this,
            variantid = parseInt(container.getAttribute("variantid")),
            cartItems = JSON.parse(localStorage.getItem('cartItemLocalStorage') || '[]'),
            item = cartItems.find(i => i.id == variantid),
            qtyValEl = container.querySelector(".qty_value");

        if(item){
          qtyValEl.textContent = item.quantity;
          qtyValEl.setAttribute("qty_value", item.quantity);
          container.classList.remove("qty_hide");
        }else{
          qtyValEl.textContent = 0;
          qtyValEl.setAttribute("qty_value", 0);
          container.classList.add("qty_hide");
        }
    }
    handleCartUpdate(e) {
      if(this.closest('.pack-of-bundle')) return;
        var container = this,
            variantid = parseInt(container.getAttribute("variantid")),
            qtyValEl = container.querySelector(".qty_value");

        if (variantid == e.detail.variantId) {
            var qty = e.detail.qty;

            qtyValEl.textContent = qty;
            qtyValEl.setAttribute("qty_value", qty);

            if (qty > 0) {
                container.classList.remove("qty_hide");
            } else {
                container.classList.add("qty_hide");
            }
        }
    }
}

if (!customElements.get("custom-qty-atc")) {
  customElements.define("custom-qty-atc", CustomQtyATC);
}

window.bundleItems = window.bundleItems || [];

function handleBundleUpdate(container, variantid, variantPrice, variantCompPrice, image, action) {
    var bundleContainer = container.closest('.pack_of_bundle_inner'),
        maxQuantity = parseInt(bundleContainer.getAttribute('data-maxQuantity')),
        qtyValEl = container.querySelector(".qty_value");

    if (action === 'add') {
        if (window.bundleItems.length < maxQuantity) {
            window.bundleItems.push({ variantid: variantid, price: variantPrice, compPrice: variantCompPrice, image: image, container: container });
        } else {
            var currentQty = parseInt(qtyValEl.getAttribute("qty_value")) || 1,
                revertedQty = currentQty - 1;

            if(revertedQty <= 0) {
                revertedQty = 0;
                container.classList.add("qty_hide");
            }
            qtyValEl.textContent = revertedQty;
            qtyValEl.setAttribute("qty_value", revertedQty);
            return;
        }
    } else if (action === 'remove') {
        var indexToRemove = window.bundleItems.map(item => item.variantid).lastIndexOf(variantid);
        if (indexToRemove !== -1) {
            window.bundleItems.splice(indexToRemove, 1);
        }
    }
    
    renderBundleCart(bundleContainer);
}

function renderBundleCart(bundleContainer) {
    var maxQuantity = parseInt(bundleContainer.getAttribute('data-maxQuantity')),
        slots = bundleContainer.querySelectorAll('.selected_product_slot'),
        totalCount = window.bundleItems.length,
        totalPrice = 0,
        comparePrice = 0,
        maxFinalPrice = bundleContainer.getAttribute('data-maxFinalPrice');

    slots.forEach((slot, index) => {
        var item = window.bundleItems[index],
            removeIcon = slot.querySelector('.remove_item'),
            img = slot.querySelector('img');

        if (item) {
            if (!img) {
                var imageTag = `<img src="${item.image}">`;
                slot.insertAdjacentHTML('beforeend', imageTag);
            } else {
                img.src = item.image;
            }
            
            slot.setAttribute('data-variantid', item.variantid);
            slot.setAttribute('data-price', item.price);

            totalPrice += item.price;
            comparePrice += item.compPrice;
        } else {
            slot.removeAttribute('data-variantid');
            if (img) img.remove(); 
        }
    });

    var selectionInfo = bundleContainer.querySelector('.selectionInfo'),
        countEl = bundleContainer.querySelector('.fillCount'),
        priceEl = bundleContainer.querySelector('.price_inner'),
        comparePriceEl = bundleContainer.querySelector('.compare_price_inner .compare_amt'),
        saveEl = bundleContainer.querySelector('.compare_price_inner .saving_amt'),
        maxPrice = totalPrice,
        savingAMT = comparePrice - maxFinalPrice;

    if (countEl) countEl.textContent = totalCount;
    
    var finalAtc = bundleContainer.querySelector('.final_atc_inner'),
        allPlusBtns = bundleContainer.querySelectorAll('.qty_btn.plus, .atc_btn_JS');

    if (totalCount >= maxQuantity) {
        finalAtc.classList.remove('disabled');
        allPlusBtns.forEach(btn => {
            btn.style.pointerEvents = 'none';
            btn.style.opacity = '0.5';
        });

        if (priceEl) priceEl.innerHTML = Shopify.formatMoney(maxFinalPrice,window.moneyFormat);
        if (savingAMT > 0 && saveEl){
            saveEl.hidden = false;
            saveEl.innerHTML = `Save ${Shopify.formatMoney(savingAMT,window.moneyFormat)}`;
        }
        selectionInfo.innerHTML = `Congratulations! you get the bundle at ${Shopify.formatMoney(maxFinalPrice,window.moneyFormat)}`;
    } else {
        finalAtc.classList.add('disabled');
        allPlusBtns.forEach(btn => {
            btn.style.pointerEvents = '';
            btn.style.opacity = '';
        });

        if (priceEl) priceEl.innerHTML = Shopify.formatMoney(maxPrice,window.moneyFormat);
        if (saveEl) saveEl.hidden = true;
        selectionInfo.innerHTML = `Select ${maxQuantity - totalCount} more item(s) to get the bundle at ${Shopify.formatMoney(maxFinalPrice,window.moneyFormat)}`;
    }

    if (comparePriceEl) comparePriceEl.innerHTML = Shopify.formatMoney(comparePrice,window.moneyFormat);
}

document.addEventListener("click", function(e) {
    var removeBtn = e.target.closest('.pack_of_bundle_inner .remove_item');
    if (removeBtn) {
        var slot = removeBtn.closest('.selected_product_slot'),
            variantid = parseInt(slot.getAttribute('data-variantid'));
        
        if (variantid && window.bundleItems) {
            var indexToRemove = window.bundleItems.map(item => item.variantid).lastIndexOf(variantid);
            
            if (indexToRemove !== -1) {
                var containerToUpdate = window.bundleItems[indexToRemove].container;
                window.bundleItems.splice(indexToRemove, 1);
                
                if (containerToUpdate) {
                    var qtyValEl = containerToUpdate.querySelector(".qty_value"),
                        currentQty = parseInt(qtyValEl.getAttribute("qty_value")) || 0,
                        newQty = currentQty - 1;
                    
                    if (newQty <= 0) {
                        newQty = 0;
                        containerToUpdate.classList.add("qty_hide");
                    }
                    
                    qtyValEl.textContent = newQty;
                    qtyValEl.setAttribute("qty_value", newQty);
                }
                
                var bundleContainer = removeBtn.closest('.pack_of_bundle_inner');
                renderBundleCart(bundleContainer);
            }
        }
    }

    var finalAtcBtn = e.target.closest('.final_atc_inner');
    if (finalAtcBtn && !finalAtcBtn.classList.contains('disabled')){
        var itemsToAdd = {};
        window.bundleItems.forEach(function(item) {
            if (itemsToAdd[item.variantid]) {
                itemsToAdd[item.variantid] += 1;
            } else {
                itemsToAdd[item.variantid] = 1;
            }
        });

        var formData = { 'items': [] };

        for (var id in itemsToAdd) {
            formData.items.push({
                'id': parseInt(id),
                'quantity': itemsToAdd[id]
            });
        }

        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => {
            return response.json();
        })
        .then(data => {
            function openGoKwik() {
                if (window.gokwikSdk) {
                    window.gokwikSdk.initCheckout(window.merchantInfo);
                } else {
                    window.location.href = '/checkout';
                }
            }
            if (window.gokwikSdk) {
                openGoKwik();
            }
        })
        .catch((error) => {
            console.error('Error adding to cart:', error);
        });
    }
});

function setPackOfBundleHeight() {
  if (document.querySelector('.pack-of-bundle .buil_bundle')) {
    var packOfBundleHeight = document.querySelector('.pack-of-bundle .buil_bundle').offsetHeight;
    document.documentElement.style.setProperty('--pack-of-bundle-height', `${packOfBundleHeight}px`);
  }
}

document.addEventListener('shopify:section:load', setPackOfBundleHeight);
document.addEventListener('DOMContentLoaded', setPackOfBundleHeight);